import React from 'react';
import Marquee from 'react-fast-marquee';
import img1 from './images/one.png';
import img2 from './images/two.png';
import img3 from './images/three.png';
import img4 from './images/four.png';
import img5 from './images/five.png';
import img6 from './images/six.png';
import img7 from './images/seven.png';
import img8 from './images/eight.png';
import img9 from './images/nine.png';
import img10 from './images/ten.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="title">
        <h1>Our Technology Partner</h1>
      </div>
      <Marquee speed={100} direction="left" pauseOnClick={true}>
        <div className="image_wrapper">
          <img src={img1} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img2} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img3} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img4} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img5} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img6} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img7} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img8} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img9} alt="Company Name" />
        </div>
        <div className="image_wrapper">
          <img src={img10} alt="Company Name" />
        </div>
      </Marquee>
    </div>
  );
}

export default App;
